// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__uIowh","content":"RecentSearches_content__38L5t"};